module.exports = "/_next/static/images/b38c55323f95ccb4db8fbb881f173536-mockup-conta-fgts@2x.jpg";